var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"allTable"},[_c('Table',{attrs:{"border":"","columns":_vm.getColumn(),"data":_vm.listdata}}),(JSON.parse(_vm.listdata[0].opt_detail).bet_list ? true : false)?_c('Table',{staticStyle:{"margin-top":"12px"},attrs:{"border":"","columns":_vm.optTabledatafruit,"data":_vm.listdata}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }